import React, { useEffect } from 'react';
import { AppSubscriptionCountry } from '../../../models/app';
import styles from './styles.module.scss';
import { PricingDetail } from './pricing-detail';
import ctx from 'classnames';
import { FreeTrialText } from '../../../component-helpers/app-details';
import { getAppDetailsRedirectedInfo, removeAppDetailsRedirectedInfo } from '../../../utils/session';
import { CoreRadio } from '@clover/web-lib-core/components';

interface ComponentProps {
  currentlySelectedSubscription?: AppSubscriptionCountry;
  handlePricingOptionChange: (subscription: AppSubscriptionCountry) => void;
  isOptionSelected: boolean;
  meteredBillingString?: string;
  subscription: AppSubscriptionCountry;
  trialText?: FreeTrialText;
}

export const PricingOption: React.FC<ComponentProps> = ({isOptionSelected, subscription, currentlySelectedSubscription, handlePricingOptionChange, meteredBillingString, trialText}): JSX.Element => {
  let { description, name, country, amount } = subscription;
  description = description || '';
  if (trialText && amount !== 0) {
    description += `${description ? '. ' : ''}${trialText.long}`
  }
  const { autoInstall, subscriptionId } = getAppDetailsRedirectedInfo();

  useEffect(() => {
    if (autoInstall && subscriptionId === subscription.appSubscription.id) {
      handlePricingOptionChange(subscription);
      removeAppDetailsRedirectedInfo();
    }
  }, [subscriptionId, autoInstall, subscription, handlePricingOptionChange]);

  const handleOptionClick = (): void => {
    if (!isOptionSelected) handlePricingOptionChange(subscription);
  }

  const keyDownHandler = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if(event.key === " " || event.key === "Enter") {
      handleOptionClick();
    }
  }

  return (
    <button role="radio" aria-checked={isOptionSelected} className={ctx(styles.subscriptionBox, styles.hasRadioButtonIcon, {[styles.selected]: isOptionSelected})} onClick={handleOptionClick} onKeyDown={keyDownHandler} tabIndex={0}>
      <CoreRadio tabIndex={-1} className={ctx(styles.iconButton, styles.icon)} onChange={handleOptionClick} label={""} checked={subscription.id === currentlySelectedSubscription?.id} value={subscription.id}/>
      <PricingDetail name={name} description={description} amount={amount} country={country} meteredBillingString={meteredBillingString}/>
    </button>
  )
}
